import * as React from 'react';
import { default as MuiSwitch, SwitchProps } from '@material-ui/core/Switch';
import { SwitchThumb } from './SwitchThumb';

export const Switch = React.forwardRef(
  (props: SwitchProps, ref: React.Ref<HTMLButtonElement>) => (
    <MuiSwitch
      checkedIcon={<SwitchThumb checked={true} {...props} />}
      icon={<SwitchThumb checked={false} {...props} />}
      ref={ref}
      disableRipple={false}
      {...props}
    />
  ),
);

export default Switch;
